export enum BusinessType {
  soleProprietorship = 'Sole Proprietorship',
  partnerShip = 'Partnership',
  limitedLiabilityCorporation = 'Limited Liability Corporation',
  coOperative = 'Co-operative',
  nonProfit = 'Non-profit Corporation',
  corporation = 'Corporation',
}

// aka Industry
export enum BusinessCategory {
  automotiveIndustry = 'AUTOMOTIVE',
  agriculture = 'AGRICULTURE',
  banking = 'BANKING',
  consumer = 'CONSUMER',
  education = 'EDUCATION',
  engineering = 'ENGINEERING',
  energy = 'ENERGY',
  oilAndGas = 'OIL_AND_GAS',
  fastMovingConsumerGoods = 'FAST_MOVING_CONSUMER_GOODS',
  financial = 'FINANCIAL',
  fintech = 'FINTECH',
  foodAndBeverage = 'FOOD_AND_BEVERAGE',
  government = 'GOVERNMENT',
  healthcare = 'HEALTHCARE',
  hospitality = 'HOSPITALITY',
  insurance = 'INSURANCE',
  legal = 'LEGAL',
  manufacturing = 'MANUFACTURING',
  media = 'MEDIA',
  online = 'ONLINE',
  rawMaterials = 'RAW_MATERIALS',
  realEstate = 'REAL_ESTATE',
  religion = 'RELIGION',
  retail = 'RETAIL',
  jewelry = 'JEWELRY',
  technology = 'TECHNOLOGY',
  telecommunications = 'TELECOMMUNICATIONS',
  transportation = 'TRANSPORTATION',
  travel = 'TRAVEL',
  electronics = 'ELECTRONICS',
  notForProfit = 'NOT_FOR_PROFIT',
}

const businessCategoryLabels = new Map<BusinessCategory, string>([
  [BusinessCategory.automotiveIndustry, 'Automotive Industry'],
  [BusinessCategory.agriculture, 'Agriculture'],
  [BusinessCategory.banking, 'Banking'],
  [BusinessCategory.consumer, 'Consumer'],
  [BusinessCategory.education, 'Education'],
  [BusinessCategory.engineering, 'Engineering'],
  [BusinessCategory.energy, 'Energy'],
  [BusinessCategory.oilAndGas, 'Oil and Gas'],
  [BusinessCategory.fastMovingConsumerGoods, 'Fast Moving Consumer Goods'],
  [BusinessCategory.financial, 'Financial'],
  [BusinessCategory.fintech, 'Fintech'],
  [BusinessCategory.foodAndBeverage, 'Food and Beverage'],
  [BusinessCategory.government, 'Government'],
  [BusinessCategory.healthcare, 'Healthcare'],
  [BusinessCategory.hospitality, 'Hospitality'],
  [BusinessCategory.insurance, 'Insurance'],
  [BusinessCategory.legal, 'Legal'],
  [BusinessCategory.manufacturing, 'Manufacturing'],
  [BusinessCategory.media, 'Media'],
  [BusinessCategory.online, 'Online'],
  [BusinessCategory.rawMaterials, 'Raw Materials'],
  [BusinessCategory.realEstate, 'Real Estate'],
  [BusinessCategory.religion, 'Religion'],
  [BusinessCategory.retail, 'Retail'],
  [BusinessCategory.jewelry, 'Jewelry'],
  [BusinessCategory.technology, 'Technology'],
  [BusinessCategory.telecommunications, 'Telecommunications'],
  [BusinessCategory.transportation, 'Transportation'],
  [BusinessCategory.travel, 'Travel'],
  [BusinessCategory.electronics, 'Electronics'],
  [BusinessCategory.notForProfit, 'Not for Profit'],
]);

export const businessCategoryToLabel = (businessCategory: BusinessCategory): string => {
  return businessCategoryLabels.get(businessCategory);
};

export enum Region {
  africa = 'AFRICA',
  asia = 'ASIA',
  europe = 'EUROPE',
  latinAmerica = 'LATIN_AMERICA',
  usaAndCanada = 'USA_AND_CANADA',
}

const regionLabels = new Map<Region, string>([
  [Region.africa, 'Africa'],
  [Region.asia, 'Asia'],
  [Region.europe, 'Europe'],
  [Region.latinAmerica, 'Latin America'],
  [Region.usaAndCanada, 'USA and Canada'],
]);

export const regionToLabel = (region: Region): string => {
  return regionLabels.get(region);
};

export enum Position {
  director = 'Director',
  gm = 'GM',
  vp = 'VP',
  ceo = 'CEO',
  cfo = 'CFO',
  generalCounsel = 'General Counsel',
  otherPosition = 'Other',
}
